import styled from 'styled-components'

export const AboutUsStyle = styled.div`
  .container{
    color: ${props=> props.theme.colors.colorText};
  }
`